<ng-template #addCompanyModal let-c="close" let-d="dismiss">
  <form #addCompanyForm="ngForm" [class.submitted]="addCompanyForm.submitted" (ngSubmit)="createRecord(addCompanyForm)"
        novalidate class="d-flex flex-wrap container">
    <div class="modal-header w-100">
      <h4 class="modal-title">{{"COMPANY.ADD_COMPANY" | translate}}</h4>
    </div>
    <div class="modal-body w-100">

      <!-- Step 1: Company Type Selection -->
      <p class="wizard-step-label">{{"COMPANY.ADD_COMPANY_STEP_1" | translate}}</p>
      <p class="wizard-step-heading">{{"COMPANY.ADD_COMPANY_STEP_1_QUESTION" | translate}}</p>
      <p class="wizard-step-sublabel">{{"COMPANY.SELECT_TYPE_LABEL" | translate}}</p>
      <div class="wizard-type-cards">
        <div class="wizard-type-card" [class.selected]="isPrivate === false"
             (click)="isPrivate=false; resetForm()"
             (keydown.enter)="isPrivate=false; resetForm()"
             (keydown.space)="isPrivate=false; resetForm()"
             tabindex="0" role="radio" [attr.aria-checked]="isPrivate === false">
          <span class="wizard-type-card-radio" [class.checked]="isPrivate === false"></span>
          <div class="wizard-type-card-content">
            <span class="wizard-type-card-title">{{"COMPANY.PUBLIC_COMPANY_TITLE" | translate}}</span>
            <span class="wizard-type-card-desc">{{"COMPANY.PUBLIC_COMPANY_DESC" | translate}}</span>
          </div>
        </div>
        <div class="wizard-type-card" [class.selected]="isPrivate === true"
             (click)="isPrivate=true; resetForm()"
             (keydown.enter)="isPrivate=true; resetForm()"
             (keydown.space)="isPrivate=true; resetForm()"
             tabindex="0" role="radio" [attr.aria-checked]="isPrivate === true">
          <span class="wizard-type-card-radio" [class.checked]="isPrivate === true"></span>
          <div class="wizard-type-card-content">
            <span class="wizard-type-card-title">{{"COMPANY.PRIVATE_COMPANY_TITLE" | translate}}</span>
            <span class="wizard-type-card-desc">{{"COMPANY.PRIVATE_COMPANY_DESC" | translate}}</span>
          </div>
        </div>
      </div>

      <!-- Step 2: Company Details -->
      <ng-container *ngIf="isPrivate !== null">
        <p class="wizard-step-label">{{"COMPANY.ADD_COMPANY_STEP_2" | translate}}</p>
        <p class="wizard-step-heading" *ngIf="!isPrivate">{{"COMPANY.ADD_COMPANY_STEP_2_PUBLIC" | translate}}</p>
        <p class="wizard-step-heading" *ngIf="isPrivate">{{"COMPANY.ADD_COMPANY_STEP_2_PRIVATE" | translate}}</p>

        <!-- Security search (public, no selection yet) -->
        <div *ngIf="isPrivate === false && !addManualPublic && !selectedSecurity" class="search-section w-100">
          <rms-security-index-search
            class="rms-security-index-search"
            [itemDescription]="'COMPANY.PUBLIC_COMPANY_TITLE' | translate"
            [createManually]="createPublicManually"
            [securitySelected]="onSecuritySelected"
          ></rms-security-index-search>
        </div>

        <!-- Form content (after selection or for private) -->
        <div class="step2-content w-100" *ngIf="isPrivate === true || selectedSecurity || addManualPublic">

          <!-- FactSet-linked public company -->
          <div *ngIf="isPrivate === false && selectedSecurity && !addManualPublic" class="security-info-card">
            <img src="assets/icons/factset-f.svg" alt="FactSet" class="security-info-card__icon security-info-card__icon--factset">
            <div class="security-info-card__content">
              <rms-security-index-search-item [item]="selectedSecurity"></rms-security-index-search-item>
            </div>
            <button type="button" class="security-info-card__close" (click)="resetForm()">×</button>
          </div>

          <!-- Manual entry (public, no FactSet link) -->
          <div *ngIf="isPrivate === false && addManualPublic" class="security-info-card">
            <img src="assets/icons/pencil-icon.svg" alt="Manual" class="security-info-card__icon security-info-card__icon--manual">
            <div class="security-info-card__content">
              <span class="security-info-card__title">{{"COMPANY.MANUAL_ENTRY_TITLE" | translate}}</span>
              <span class="security-info-card__desc">{{"COMPANY.MANUAL_ENTRY_DESC" | translate}}</span>
            </div>
            <button type="button" class="security-info-card__close" (click)="addManualPublic = false">×</button>
          </div>

          <!-- Private company -->
          <div *ngIf="isPrivate === true" class="security-info-card">
            <img src="assets/icons/shield.svg" alt="Private" class="security-info-card__icon security-info-card__icon--private">
            <div class="security-info-card__content">
              <span class="security-info-card__title">{{"COMPANY.PRIVATE_COMPANY_TITLE" | translate}}</span>
              <span class="security-info-card__desc">{{"COMPANY.PRIVATE_COMPANY_CARD_DESC" | translate}}</span>
            </div>
          </div>

          <!-- Row 1: RMS Company Name | Domain -->
          <div class="row flex-grow-1 w-100">
            <div class="form-group col-12 col-md-6">
              <label for="name">{{"COMPANY.RMS_COMPANY_NAME" | translate}}:<sup style="color:#FF0000;">*</sup>
                <rms-required-label [componentForm]="addCompanyForm" [formFieldReference]="nameRef"></rms-required-label>
              </label>
              <input id="name" name="name" [(ngModel)]="name" #nameRef="ngModel" class="form-control" required>
            </div>
            <div class="col-12 col-md-6">
              <div class="form-group">
                <rms-domain-selector #domainsRef="ngModel" [(ngModel)]="domains" [multiple]="true"
                                     [relevances]="domainRelevances" name="domains"
                                     [label]="'GENERICS.DOMAINS' | translate"
                                     [isRequired]="tenantId === DEFAULT_TENANT_ID"></rms-domain-selector>
                <span class="error" *ngIf="addCompanyForm && addCompanyForm.submitted">
                  <span *ngIf="addCompanyForm && tenantId === DEFAULT_TENANT_ID && (!domains || domains.length === 0)">
                    {{"ERRORS.IS_REQUIRED" | translate | uppercase}}
                  </span>
                </span>
              </div>
            </div>
          </div>

          <!-- Row 2: Tenant | Company Category -->
          <div class="row flex-grow-1 w-100">
            <div class="form-group col-xs-12 col-md-6">
              <label for="tenantId">
                {{"GENERICS.TENANT" | translate}}:
                <rms-required-label [componentForm]="addCompanyForm" [formFieldReference]="tenantIdRef"></rms-required-label>
              </label>
              <ng-select name="tenantId" id="tenantId" [(ngModel)]="tenantId" #tenantIdRef="ngModel" required [clearable]="false">
                <ng-option *ngFor="let item of tenantList?.records" [value]="item.id">{{item.name}}</ng-option>
              </ng-select>
            </div>
            <div class="form-group col-12 col-md-6">
              <label for="categoryId">
                {{"COMPANY.COMPANY_CATEGORY" | translate}}
                <rms-required-label [componentForm]="addCompanyForm" [formFieldReference]="companyCategory"></rms-required-label>
              </label>
              <ng-select name="categoryId" id="categoryId" [(ngModel)]="categoryId"
                         #companyCategory="ngModel" required [clearable]="false">
                <ng-option *ngFor="let category of companyCategories?.records" [value]="category.id">{{category.name}}</ng-option>
              </ng-select>
            </div>
          </div>

          <!-- Row 3: Ticker | Exchange (editable, manual public) -->
          <div class="row flex-grow-1 w-100" *ngIf="addManualPublic">
            <div class="form-group col-12 col-md-6">
              <label for="ticker" class="text-uppercase">{{"COMPANY.TICKER" | translate}}*
                <span class="error" *ngIf="addCompanyForm.submitted">
                  <span *ngIf="tickerRef.errors?.required">{{"ERRORS.IS_REQUIRED" | translate}}</span>
                </span>
              </label>
              <input id="ticker" name="ticker" [(ngModel)]="ticker" #tickerRef="ngModel"
                class="form-control" required placeholder="e.g., ASND" autocomplete="off" data-1p-ignore>
            </div>
            <div class="form-group col-12 col-md-6">
              <label for="exchangeId" class="text-uppercase">{{"FINANCIAL.EXCHANGE" | translate}}*
                <span class="error" *ngIf="addCompanyForm.submitted">
                  <span *ngIf="exchangeRef.errors?.required">{{"ERRORS.IS_REQUIRED" | translate}}</span>
                </span>
              </label>
              <select class="form-control" id="exchangeId" name="exchangeId" #exchangeRef="ngModel"
                      [(ngModel)]="exchangeId" required>
                <option value="" disabled selected hidden>{{"FINANCIAL.SELECT_EXCHANGE" | translate}}</option>
                <option *ngFor="let exchange of exchangeList?.records" [value]="exchange.id">{{exchange.name}}</option>
              </select>
            </div>
          </div>

          <!-- Row 4: Currency (editable, manual public) -->
          <div class="row flex-grow-1 w-100" *ngIf="addManualPublic">
            <div class="form-group col-12 col-md-6">
              <label for="currency" class="text-uppercase">{{"FINANCIAL.CURRENCY.TITLE" | translate}}*
                <span class="error" *ngIf="addCompanyForm.submitted">
                  <span *ngIf="currencyRef.errors?.required">{{"ERRORS.IS_REQUIRED" | translate}}</span>
                </span>
              </label>
              <select class="form-control" id="currency" name="currency" #currencyRef="ngModel"
                      [(ngModel)]="currency">
                <option [value]="c.code" *ngFor="let c of currencyList">{{c.name}}</option>
              </select>
            </div>
          </div>

          <!-- Row 5: Company Description -->
          <div class="row flex-grow-1 w-100">
            <div class="form-group col-12">
              <label for="description">
                {{"GENERICS.COMPANY" | translate}} {{"GENERICS.DESCRIPTION" | translate}}
              </label>
              <textarea name="description" id="description" [(ngModel)]="description" class="form-control"
                        maxlength="150"></textarea>
              <div class="description-hint">
                <img ngSrc="assets/icons/ai/tara-actually/tara-logo-icon.svg" alt="Tara Logo" class="tara-logo"
                     height="12" width="12">
                {{"COMPANY.ADD_DESCRIPTION_HINT" | translate}}
              </div>
            </div>
          </div>

        </div><!-- end step2-content -->
      </ng-container>

    </div>
    <div class="modal-footer col-12">
      <button type="button" class="btn btn-default" (click)="c()">{{"GENERICS.CANCEL" | translate}}</button>
      <button type="submit" class="btn btn-primary" [disabled]="formInvalid(addCompanyForm)">{{"COMPANY.CREATE_COMPANY" | translate}}</button>
    </div>
  </form>
</ng-template>
